export class TotalSourceStorageSizeResponse {
    'totalSourceStorageSizeBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalSourceStorageSizeBytes",
            "baseName": "totalSourceStorageSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return TotalSourceStorageSizeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
